"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEEFO_POPUP_SCRIPT_ID = exports.ONLY_TWO_VARIANTS_LANGUAGES = exports.ALL_LANGUAGES_REVIEWS_KEY = exports.START_NUMBER_REVIEWS = void 0;
exports.START_NUMBER_REVIEWS = 3;
exports.ALL_LANGUAGES_REVIEWS_KEY = 'all';
exports.ONLY_TWO_VARIANTS_LANGUAGES = 2;
exports.FEEFO_POPUP_SCRIPT_ID = 'feefo-popup-script';
